import { AccountingBalancePostingsService_balancePostingsServiceGetQuery } from '@festina/life-general-types/life/hooks/AccountingBalancePostingsService_balancePostingsServiceGetQuery'

export const useFetchAccountBalancePostings =
  AccountingBalancePostingsService_balancePostingsServiceGetQuery.useSuspenseQuery
